var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "input",
    attrs: {
      disabled: _vm.disabled,
      fancy: _vm.fancy,
      icon: _vm.icon,
      "icon-left": _vm.iconLeft,
      "input-delay": 500,
      items: _vm.foundContacts,
      label: _vm.label,
      open: true,
      "icon-left-tooltip": _vm.iconLeftTooltip,
      "icon-tooltip": _vm.iconTooltip,
      "empty-on-focus": "",
    },
    on: {
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      "icon-click": function ($event) {
        return _vm.searchContacts()
      },
      "icon-left-click": function ($event) {
        return _vm.iconLeftClick()
      },
      "item-click": function ($event) {
        return _vm.selectContact($event)
      },
      keyup: function ($event) {
        return _vm.keyup($event)
      },
      "realtime-value": function ($event) {
        return _vm.onRealTimeValue($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (p) {
          return [
            _c("div", [
              _vm._v(" " + _vm._s(p.item.MainAddress.CompanyName) + " "),
              p.item.MainAddress.FirstName || p.item.MainAddress.LastName
                ? _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(p.item.MainAddress.CompanyName ? "(" : "") +
                        " " +
                        _vm._s(p.item.MainAddress.FirstName) +
                        " " +
                        _vm._s(p.item.MainAddress.LastName) +
                        " " +
                        _vm._s(p.item.MainAddress.CompanyName ? ")" : "") +
                        " "
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "smaller" }, [
              p.item.MainAddress.AddressLine1
                ? _c("span", [
                    _vm._v(
                      _vm._s(p.item.MainAddress.AddressLine1) +
                        " | " +
                        _vm._s(p.item.MainAddress.City)
                    ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "smaller" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$ct(p.item.GroupID === 2 ? "supplier-id" : "contact-id")
                  ) +
                    " " +
                    _vm._s(p.item.ComputedFriendlyID)
                ),
              ]),
              p.item.Vat
                ? _c("span", [_vm._v(" | " + _vm._s(p.item.Vat))])
                : _vm._e(),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.input,
      callback: function ($$v) {
        _vm.input = $$v
      },
      expression: "input",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }